import React, { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { AppContext } from "../AppContextProvider";
import { newFolder2, firstLink2 } from "../utils/graph/graphmodifier2";
import { unProcessAndSaveProcessedGraphJwt } from "../utils/graph/graphloader2";
import { loadJwt } from "../utils/dwclient/localstorage/jwtStorage";

import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalFooter,
  MDBModalBody,
  MDBModalHeader,
  MDBSelect,
  MDBInput,
  MDBBtn,
} from "mdb-react-ui-kit";
import { DwMpcWalletBackendProviderContext } from "../mpcwalletprovider/DwMpcWalletBackendProvider";
import { contains } from "validator";
import FormGroup from "rsuite/esm/FormGroup";

export default function CreateFolderNameModal(props) {
  const { t } = useTranslation();
  const context = useContext(AppContext);
  const { storageProps } = useContext(DwMpcWalletBackendProviderContext);

  const [newFolderName, setNewFolderName] = useState("");

  const createNode = async () => {
    try {
      const oldFolderId = newFolder2(props.modalParam.processedGraph, newFolderName);
      const newFolderId = firstLink2(props.modalParam.processedGraph, props.modalText, oldFolderId);
      // save
      //await unProcessAndSaveProcessedGraph2(storageProps, props.modalParam.processedGraph);
      const authToken = await loadJwt();
      //props.modalParam.processedGraph.nodes = [];
      await unProcessAndSaveProcessedGraphJwt(authToken, props.modalParam.processedGraph);
      setTimeout(() => {
        //context.onSetIsRender();
        if (props.modalParam?.onFinish) {
          props.modalParam.onFinish();
        }
      }, 500);
    } catch (error) {
      setTimeout(() => {
        if (props.modalParam?.onError) {
          props.modalParam.onError();
        }
      }, 500);
    }
  };

  const onHide = () => {
    if (props.modalParam?.onHide) {
      props.modalParam.onHide();
    }
  };

  return (
    <>
      <MDBModal staticBackdrop tabIndex="-1" closeOnEsc={false} show={props.visible} className="new-foldername-modal">
        <MDBModalDialog scrollable centered size="lg">
          <MDBModalContent>
            <MDBModalHeader>
              <div className="title-text">{t('modals.folder.nameTitle')}</div>
              <button
                type="button"
                className="button outline medium"
                onClick={() => onHide()}
                style={{ minWidth: "unset" }}
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.06056 8.00001L11.5303 5.53028C11.8233 5.23731 11.8233 4.7627 11.5303 4.46973C11.2373 4.17676 10.7627 4.17676 10.4697 4.46973L8.00001 6.93946L5.53028 4.46973C5.23731 4.17676 4.7627 4.17676 4.46973 4.46973C4.17676 4.7627 4.17676 5.23731 4.46973 5.53028L6.93946 8.00001L4.46973 10.4697C4.17676 10.7627 4.17676 11.2373 4.46973 11.5303C4.61621 11.6768 4.80762 11.75 5 11.75C5.19238 11.75 5.38379 11.6768 5.53027 11.5303L8 9.06056L10.4697 11.5303C10.6162 11.6768 10.8076 11.75 11 11.75C11.1924 11.75 11.3838 11.6768 11.5303 11.5303C11.8232 11.2373 11.8232 10.7627 11.5303 10.4697L9.06054 8.00001H9.06056Z"
                    fill="#2BBCD9"
                  />
                </svg>
              </button>
            </MDBModalHeader>
            <MDBModalBody>
              <div className="path-select-div">
                <div className="select-div">
                  <MDBInput
                    label={t('modals.folder.newFolderLabel')}
                    id="form1"
                    type="text"
                    onChange={(event) => setNewFolderName(event.target.value)}
                  />
                </div>
              </div>
            </MDBModalBody>
            <MDBModalFooter>
              <div className="info-div"></div>
              <div className="actions-button-div">
                <button className="button subtle medium " onClick={() => onHide()}>
                  <span className="text">{t('common.buttons.cancel')}</span>
                </button>
                <button
                  className="button accent medium "
                  disabled={newFolderName.length === 0}
                  onClick={() => {
                    onHide();
                    createNode();
                  }}
                >
                  <span className="text">{t('common.buttons.save')}</span>
                </button>
              </div>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}
